<div class="switcher" (keydown)="onKeydown($event)">
  <!-- Busca: o foco nasce aqui. type=search + appBlockAutofill: sem isso o gerenciador de senhas do
       Chrome oferece credenciais salvas neste campo. -->
  <div class="switcher-search">
    <i class="ti ti-search switcher-search-icon"></i>
    <input #searchInput appBlockAutofill type="search" class="switcher-search-input" autocomplete="off"
      name="mc_company_search" placeholder="Buscar por empresa, grupo ou CNPJ" aria-label="Buscar empresa"
      [(ngModel)]="term" (ngModelChange)="onTermChange()" />
    <!-- "Limpar" escrito, não outro ×: dois × lado a lado (limpar a busca e fechar o seletor) eram
         indistinguíveis. O × é SEMPRE fechar — no celular não existe Esc. -->
    @if (term) {
    <button type="button" class="btn btn-xs btn-text-secondary" (click)="clearSearch()">Limpar</button>
    }
    <button type="button" class="btn btn-sm btn-icon btn-text-secondary rounded-circle"
      (click)="modal.dismiss()" aria-label="Fechar"><i class="ti ti-x"></i></button>
  </div>

  <div class="switcher-body">
    <!-- Grupos: coluna no desktop, faixa de chips rolável no celular. -->
    <nav class="switcher-groups" aria-label="Grupos de empresas">
      <button type="button" class="switcher-group" [class.is-selected]="groupId === null" (click)="selectGroup(null, $event)">
        <span class="switcher-group-all"><i class="ti ti-building-community"></i></span>
        <span class="switcher-group-name">Todos os grupos</span>
        <span class="switcher-group-count">{{ matchTotal }}</span>
      </button>
      @if (hasFavorites) {
      <button type="button" class="switcher-group" [class.is-selected]="groupId === FAVORITES_ID"
        [class.is-empty]="favoritesTotal === 0" (click)="selectGroup(FAVORITES_ID, $event)">
        <span class="switcher-group-all switcher-group-fav"><i class="ti ti-star-filled"></i></span>
        <span class="switcher-group-name">Favoritas</span>
        <span class="switcher-group-count">{{ favoritesTotal }}</span>
      </button>
      }
      @for (group of groups; track group.id) {
      <button type="button" class="switcher-group" [class.is-selected]="groupId === group.id"
        [class.is-empty]="countFor(group) === 0" (click)="selectGroup(group.id, $event)">
        <app-avatar size="avatar-xs" tone="primary" [nome]="group.name" [url]="group.avatarUrl || ''"></app-avatar>
        <span class="switcher-group-name">{{ group.name }}</span>
        <span class="switcher-group-count">{{ countFor(group) }}</span>
      </button>
      }
    </nav>

    <!-- Grupo de botões, não listbox: listbox só aceita option, e cada linha tem dois botões (a
         empresa e a estrela). As setas continuam valendo — quem as trata é o (keydown) da raiz. -->
    <div #list class="switcher-list" role="group" aria-label="Empresas">
      @for (group of visible; track group.id) {
      <!-- Marca SEMPRE no cabeçalho: o ícone do grupo ou, sem ele, as iniciais em tom neutro (grupos
           com e sem ícone ficam alinhados). Contagem à direita. -->
      <p class="switcher-list-group">
        @if (group.id === FAVORITES_ID) {<i class="ti ti-star-filled"></i>}
        @else {<app-avatar class="switcher-list-group-icon" size="avatar-xs" tone="primary" [nome]="group.name" [url]="group.avatarUrl || ''"></app-avatar>}
        <span class="switcher-list-group-name">{{ group.name }}</span>
        <span class="switcher-list-group-count">{{ group.companies.length }}</span>
      </p>
      @if (group.id === FAVORITES_ID && groupId === null) {
      <!-- Acesso rápido: favoritas como chips (nome + grupo em cinza), quebrando linha sozinhas.
           Em linha cheia, com razão social e CNPJ, umas poucas já enchiam a lista; em grade com
           borda, cortavam o nome. O detalhe completo continua na linha do grupo e no recorte
           "Favoritas". -->
      <div class="switcher-fav-grid">
        @for (company of group.companies; track company.id) {
        <div class="switcher-row" [attr.data-section]="group.id" [attr.data-company]="company.id"
          (mouseenter)="activeIndex = indexOf(group.id, company)">
          <button type="button" class="switcher-company switcher-chip"
            [class.is-active]="indexOf(group.id, company) === activeIndex" [class.is-current]="company.id === currentId"
            [attr.aria-current]="company.id === currentId ? 'true' : null"
            (click)="choose(company)">
            <app-avatar size="avatar-xs" tone="primary" [nome]="company.fantasyName || company.name" [url]="company.avatarUrl || ''"></app-avatar>
            <span class="switcher-company-name">{{ company.fantasyName || company.name }}</span>
            <span class="switcher-chip-group">{{ groupLabel(company) }}</span>
          </button>
          <!-- Sem estrela no chip: aqui todas são favoritas e, no toque, sete estrelas acesas só
               poluíam. Desfavoritar é pela linha do grupo (logo abaixo) ou no recorte "Favoritas". -->
        </div>
        }
      </div>
      } @else {
      @for (company of group.companies; track company.id) {
      <!-- Estrela IRMÃ da linha, não dentro dela: botão dentro de botão é HTML inválido e o clique
           na estrela também escolheria a empresa. data-section/data-company: keepFocus() acha a
           linha focada e a vizinha. -->
      <div class="switcher-row" [attr.data-section]="group.id" [attr.data-company]="company.id"
        (mouseenter)="activeIndex = indexOf(group.id, company)">
        <button type="button" class="switcher-company"
          [class.is-active]="indexOf(group.id, company) === activeIndex" [class.is-current]="company.id === currentId"
          [attr.aria-current]="company.id === currentId ? 'true' : null"
          (click)="choose(company)">
          <app-avatar size="avatar-sm" tone="primary" [nome]="company.fantasyName || company.name" [url]="company.avatarUrl || ''"></app-avatar>
          <span class="switcher-company-text">
            <span class="switcher-company-name">{{ company.fantasyName || company.name }}</span>
            <!-- Na seção Favoritas as empresas vêm de grupos diferentes: o grupo vai junto. -->
            @if (subtitle(group.id, company); as sub) {
            <span class="switcher-company-legal">{{ sub }}</span>
            }
          </span>
          <span class="switcher-company-meta">
            @if (company.id === currentId) {
            <span class="switcher-current">Atual</span>
            }
            @if (company.cnpj) {
            <span class="switcher-cnpj">{{ formatCnpj(company.cnpj) }}</span>
            }
          </span>
        </button>
        <ng-container *ngTemplateOutlet="favStar; context: { $implicit: company }"></ng-container>
      </div>
      }
      }
      } @empty {
      <div class="switcher-empty">
        <i class="ti ti-building-off"></i>
        <p class="mb-1 fw-medium text-heading">Nenhum resultado</p>
        <p class="mb-0 small text-muted">Busque pelo nome, grupo ou parte do CNPJ.</p>
      </div>
      }
    </div>
  </div>

  <!-- Estrela: a mesma na linha do grupo e no bloco de acesso rápido. -->
  <ng-template #favStar let-company>
    <button type="button" class="switcher-fav" [class.is-on]="company.isFavorite"
      [class.is-pending]="pending.has(company.id)" [attr.aria-pressed]="!!company.isFavorite"
      [attr.aria-label]="favoriteLabel(company)"
      [ngbTooltip]="company.isFavorite ? 'Remover das favoritas' : 'Favoritar'" container="body"
      triggers="hover" [disableTooltip]="!hoverCapable" (click)="toggleFavorite(company, $event)">
      <i class="ti" [class.ti-star-filled]="company.isFavorite" [class.ti-star]="!company.isFavorite"></i>
    </button>
  </ng-template>

  <div class="switcher-foot">
    <span>{{ total }} {{ total === 1 ? 'empresa' : 'empresas' }} em {{ groups.length }} {{ groups.length === 1 ? 'grupo' : 'grupos' }}</span>
    <span class="switcher-keys d-none d-md-inline">
      <kbd>↑</kbd><kbd>↓</kbd> navegar <kbd>Enter</kbd> trocar <kbd>Esc</kbd> fechar
      <i class="ti ti-star ms-2"></i> favoritar
    </span>
  </div>
</div>
